import React from "react";
import { getNairaFormat } from "../../../utils/Utils";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveProduct, setProductData } from "../LeaseSlice";

function ProductCard({ data }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	// console.log(data);
	const Tags = ({ tag }) => {
		return (
			<div style={{ backgroundColor: "#E3E9EC" }} className='border'>
				{tag}
			</div>
		);
	};

	const handleData = () => {
		//set product data so it can be displayed in product information page
		dispatch(setProductData(data));
		dispatch(saveProduct(data));
		navigate("/lease/create_asset/lease_info");
	};
	return (
		<section onClick={handleData} className='productCard flex border mt-4'>
			<div className='flex gap-4 py-4 px-4'>
				<img
					style={{ width: "200px" }}
					className='objectFit border'
					src={data?.image || "/images/placeholder_img.jpg"}
					alt='primary image'
				/>
				<img
					style={{ width: "200px" }}
					className='objectFit border'
					src={data?.secondImage || "/images/placeholder_img.jpg"}
					alt='secondary image'
				/>
			</div>
			<div className='flex-col  gap-4 py-4 px-4'>
				<p className='name fw-500'>{data?.productName}</p>
				<p className='price fw-500'>
					Asset Value :{" "}
					<span style={{ color: "#00525D" }} className='fw-500'>
						{getNairaFormat(data?.amount)}
					</span>
				</p>
				<p className='shelfLife fw-500'>Shelf life: {data?.shelfLife}</p>
				{/* <p className='info'>Product information</p> */}
				<div className='tags flex gap-4'>
					{data?.tags?.map((tag, index) => (
						<Tags tag={tag} key={index} />
					))}
				</div>
			</div>
		</section>
	);
}

ProductCard.propTypes = {
	data: PropTypes.object.isRequired,
	tag: PropTypes.arrayOf(PropTypes.string),
};

export default ProductCard;
